import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import { enableIndexedDbPersistence, getFirestore, type Firestore } from 'firebase/firestore'

let _app: FirebaseApp | null = null
let _auth: Auth | null = null
let _db: Firestore | null = null
let persistencePromise: Promise<void> | null = null

function getApp(): FirebaseApp {
  if (_app) return _app
  const existing = getApps()
  if (existing.length > 0) {
    _app = existing[0]!
    return _app
  }
  _app = initializeApp({
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  })
  return _app
}

export function getFirebaseAuth(): Auth {
  if (_auth) return _auth
  _auth = getAuth(getApp())
  _auth.useDeviceLanguage()
  return _auth
}

export function getDb(): Firestore {
  if (_db) return _db
  _db = getFirestore(getApp())
  return _db
}

export function enableOfflinePersistence(): Promise<void> {
  if (persistencePromise) return persistencePromise
  persistencePromise = enableIndexedDbPersistence(getDb()).catch((err: unknown) => {
    console.warn('Firestore offline persistence unavailable.', err)
  })
  return persistencePromise
}
